module.exports = __webpack_public_path__ + "img/145.46b88388.png";